import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';

declare var ZaigWebFaceRecon: any;

@Component({
  selector: 'app-face-recognition',
  templateUrl: './face-recognition.component.html',
  styleUrls: ['./face-recognition.component.css']
})
export class FaceRecognitionComponent extends ComponentBase implements OnInit, AfterViewInit {

  @ViewChild('faceReconHost')
  faceReconHost: ElementRef;
  message: string;
  hasMobileError: boolean;
  isDemoMode: boolean = false;
  showCapturingMessage: boolean = true;
  private initialized: boolean = false;

  ngOnInit(): void {
    this.checkDemoMode();
  }

  checkDemoMode(): void {
    const demoModeOption = this.getOptionByKey(this.attribute, 'DemoMode', 'false');
    this.isDemoMode = demoModeOption.toLowerCase() === 'true';
  }

  ngAfterViewInit() {
    if (this.initialized) {
      return;
    }

    if(this.checkViewMode("edit")) {
      this.initialized = true;
      if (this.isDemoMode) {
        this.initializeDemoMode();
      } else {
        this.initializeFaceRecognition();
      }
    } else {
      this.message = "Face recognition component in view mode."
    }
  }

  initializeDemoMode() {
    setTimeout(() => {
      this.showCapturingMessage = false;
      this.attribute.value = 'demo-selfie-mock-data';
      swal.fire('Sucesso', 'A foto foi capturada com sucesso', 'success');
    }, 3000);
  }

  initializeFaceRecognition() {
    const hostComponent = this.faceReconHost.nativeElement;
    const webFaceRecon = new ZaigWebFaceRecon.WebFaceRecon(
      hostComponent,
      environment.faceReconKey
    )
    .setSessionId('fac9116c-92ff-4bb2-8370-8fc2ba221508')
    .build();

    webFaceRecon.initialize().then(res => {
      const promise = webFaceRecon.open();
      promise
        .then(res => {
          this.attribute.value = res;
          this.emit({
            attribute: {
              key: "Capturar fotografia",
              type: "task",
              attributes: [],
              options: []
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }).catch(error => {
      if (error.includes('not mobile')) {
        this.message = 'Para fazer o reconhecimento facial é necessário estar em um dispositivo móvel (celular ou tablet). Você pode clicar em \"Receber SMS\" ou \"Receber Whatsapp\" para receber um link e continuar o seu cadastro.';
        this.hasMobileError = true;
      }
    });
  }

  sendSMS() {
    this.emit({
      attribute: {
        key: "Receber SMS",
        type: "actionButton",
        attributes: [],
        options: []
      }
    })
  }

  sendWhatsapp() {
    this.emit({
      attribute: {
        key: "Receber Whatsapp",
        type: "actionButton",
        attributes: [],
        options: []
      }
    })
  }
}